import React, { RefCallback, createRef, forwardRef } from 'react';
import { masks } from '@src/common/masks';
import { HelperText, Label, StyledInput, WrapperInputMask } from './styles';

type Mask = keyof typeof masks;

type InputProps = Omit<JSX.IntrinsicElements['input'], 'name'> & {
  name: string;
  mask?: Mask | Mask[];
  error?: boolean;
  label?: string;
  helperText?: React.ReactNode | string;
  value?: any;
  onChange: (event: { target: { name: string; value: string } }) => void;
};

const Input = forwardRef<HTMLInputElement, InputProps>((props: InputProps, inputRef: React.Ref<HTMLInputElement>) => {
  const { mask, error = false, label, helperText, name, type, value, onChange = () => {}, ...rest } = props;
  const ref = createRef();

  const getMask = (mask: string | string[]) => {
    if (Array.isArray(mask)) {
      return mask.map((mask) => ({ mask: masks[mask as keyof typeof masks] }));
    }

    return [{ mask: masks[mask as keyof typeof masks] }];
  };

  return (
    <WrapperInputMask>
      {label && type !== 'hidden' ? <Label htmlFor={name}>{label}</Label> : null}

      <StyledInput
        {...rest}
        type={type}
        inputRef={inputRef as RefCallback<IMask.MaskElement>}
        name={name}
        ref={ref}
        mask={mask ? getMask(mask) : undefined}
        value={value}
        unmask={true}
        $error={error}
        onChange={onChange}
        onAccept={(value: any) => {
          onChange({ target: { name, value } });
        }}
      />

      {helperText ? <HelperText error={error}>{helperText}</HelperText> : null}
    </WrapperInputMask>
  );
});

Input.displayName = 'Input';

export default Input;
